import { useGetSportsQuery } from 'app/imports/App.hooks'
import { UISelect } from 'features/UI'
import { useAppDispatch } from 'hooks'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { OnChangeValue } from 'react-select'
import { Sport } from 'types'
import { setFilterDate, setFilterSport } from '../../state/Filters.reducer'
import { getIsSportChangeable, getSelectedSport } from '../../state/Filters.selectors'
import * as Styled from './FiltersByDistrict.styled'

export function FiltersByDistrict() {
  const dispatch = useAppDispatch()

  const { data: sports } = useGetSportsQuery()

  const selectedSport = useSelector(getSelectedSport)
  const isSportChangeable = useSelector(getIsSportChangeable)

  const sportItems = useMemo(() => {
    if (!sports) {
      return []
    }

    return sports.items.filter((sport) => !sport.isParent)
  }, [sports])

  const handleSportChange = (sport: OnChangeValue<Sport, false>) => {
    dispatch(setFilterDate(null))
    dispatch(setFilterSport(sport ? [sport] : []))
  }

  if (!sports || !isSportChangeable) {
    return null
  }

  return (
    <Styled.FiltersContainer>
      <UISelect<Sport, false>
        options={sportItems}
        value={selectedSport && selectedSport.length > 0 ? selectedSport[0] : null}
        onChange={handleSportChange}
        isMulti={false}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        placeholder="Search Sport"
      />
    </Styled.FiltersContainer>
  )
}
